<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" i18n="@@modalTitle" id="modal-header">Already Logged In!</h3>
    <button
      type="button"
      class="close"
      aria-label="Already Logged In Close"
      ngbAutoFocus
      (click)="activeModal.dismiss('Cross click')"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body" i18n="@@modalBody">
    You are already authenticated on another device. Do you want to continue and log out the other
    session, or close this session? If you did not expect this message, please consider changing
    your password or contacting support.
  </div>
  <div class="modal-footer">
    <button
      type="button"
      appButton="small"
      class="small-button--no"
      (click)="activeModal.close(false)"
      i18n="@@modalCancel"
    >
      Cancel
    </button>
    <button
      type="button"
      id="button_ok"
      appButton="small"
      (click)="activeModal.close(true)"
      i18n="@@modalOK"
    >
      Ok
    </button>
  </div>
</div>
